import React from 'react';
import {ButtonGroup, Dialog, DialogActions, DialogProps, DialogTitle, Paper} from '@mui/material';
import {BodyText} from './PWMTypography';
import {ButtonDefault, ButtonSecondary} from './PWMButtons';
import SlideUpTransitionComponent from './SlideTransitionComponent';
const ConfirmationDialog: React.FC<IConfirmationDialogProps> = (props) => {
  const message = Array.isArray(props.message) ? props.message.map((m) => <><BodyText>{m}</BodyText><br /></>) :
    <BodyText>{props.message}</BodyText>;
  return (
    <Dialog
      open={props.isOpen}
      onClose={props.onClose}
      TransitionComponent={SlideUpTransitionComponent}
      maxWidth={props.maxWidth || "xl"}
      fullWidth={props.fullWidth}
      aria-labelledby="confirmation-modal"
    >
      <DialogTitle id="confirmation-modal">{props.title}</DialogTitle>
      <Paper sx={{
        margin(theme){return theme.spacing(2)},
        marginTop: 0,
        padding(theme) {return theme.spacing(1);}
      }} elevation={0}>
        {message}
        {props.children}
      </Paper>
      <DialogActions>
        <ButtonGroup fullWidth={true} variant="contained">
          {typeof props.onOk == 'function' &&
            <ButtonSecondary disabled={props.buttonsDisabled || false} name={`OK for ${props.title}`} onClick={props.onOk}>{props.okButtonText || 'OK'}</ButtonSecondary>}
          <ButtonDefault disabled={props.buttonsDisabled || false} onClick={props.onClose}>{props.closeButtonText || 'Close'}</ButtonDefault>
        </ButtonGroup>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationDialog;

export interface IConfirmationDialogProps extends Pick<DialogProps, 'maxWidth' | 'fullWidth'> {
  children?: React.ReactNode;
  title: string;
  message: string | string[];
  isOpen: boolean;
  buttonsDisabled?: boolean;
  okButtonText?: string;
  closeButtonText?: string;
  onOk?(e?: any): any;
  onClose(): any;
}